import { useEffect, useMemo } from 'react';
import Dropdown from '../../../Components/Form/Inputs/Dropdown';
import LabelWithTooltip from '../../../Components/Form/Inputs/LabelWithTooltip';
import useLanguage from '../../../Services/Language/useLanguageHook';

type ForwardCurveYearAverageOptionsType = { label: string; value: number };

interface IForwardCurveYearAverageDropdownProps {
    disabled?: boolean;
    value: number | undefined;
    handleChange: (value: number | undefined) => void;
    label?: string;
}

const ForwardCurveYearAverageDropdown: React.FC<IForwardCurveYearAverageDropdownProps> = (props): JSX.Element => {
    const [translations] = useLanguage();

    const forwardCurveYearAverageDropdownOptions = useMemo(
        () => [
            {
                label: translations.calculators.forwardSpread.yearAverageDropdown.labels.none,
                value: undefined,
            },
            {
                label: translations.calculators.forwardSpread.yearAverageDropdown.labels.oneYearAverage,
                value: 1,
            },
            {
                label: translations.calculators.forwardSpread.yearAverageDropdown.labels.threeYearAverage,
                value: 3,
            },
            {
                label: translations.calculators.forwardSpread.yearAverageDropdown.labels.fiveYearAverage,
                value: 5,
            },
        ],
        [translations],
    ) as ForwardCurveYearAverageOptionsType[];

    useEffect(() => {
        if (props.value) {
            return;
        }

        props.handleChange(forwardCurveYearAverageDropdownOptions[0].value);
    }, []);

    return (
        <LabelWithTooltip
            title={
                <Dropdown
                    disabled={props.disabled ?? false}
                    value={props.value}
                    options={forwardCurveYearAverageDropdownOptions}
                    handleOptionChange={(value: number) => props.handleChange(value)}
                    label={props.label}
                    track={{ eventCategory: 'ForwardSpreadCalculator', eventAction: 'ChartYearAverageChanged' }}
                />
            }
            tooltip={translations.calculators.forwardSpread.yearAverageDropdown.tooltip}
        />
    );
};

export default ForwardCurveYearAverageDropdown;
